// ProductSearchModal.tsx
import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField
} from '@mui/material';
import api from '../../services/api';

import PaginationControls from '../PaginationControls';
import { ProductSearchCard, Table, TableContainer } from '../style/ProductSearchModal.styled';
import { ProductInterface } from '../../common/interfaces';

interface ProductSearchModalProps {
    open: boolean;
    onClose: () => void;
    // onSelectProduct: (product: ProductInterface) => void;
}

const ProductSearchModal: React.FC<ProductSearchModalProps> = ({
    open,
    onClose,
    // onSelectProduct
}) => {
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [products, setProducts] = useState<ProductInterface[]>([]);
    const [page, setPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(false);

    // Função para buscar produtos via /products/location
    const fetchProducts = async (currentPage: number, filtro: string) => {
        setLoading(true);
        try {
            const params: any = {
                page: currentPage,
                limit: 8,
                sort: 'ASC',
                orderBy: 'DATE'
            };

            if (filtro.trim() !== '') {
                params.product_name = filtro.trim();
            }

            const response = await api.get<{
                items: ProductInterface[];
                meta: { totalPages: number };
            }>('/products/location', { params });

            setProducts(response.data.items);
            setTotalPages(response.data.meta.totalPages);
        } catch (err) {
            console.error('Erro ao buscar produtos no modal:', err);
            setProducts([]);
            setTotalPages(1);
        } finally {
            setLoading(false);
        }
    };

    // Dispara a busca sempre que mudar página ou termo de pesquisa
    useEffect(() => {
        if (open) {
            fetchProducts(page, searchTerm);
        }
    }, [open, page, searchTerm]);

    const handleClose = () => {
        // Ao fechar, zera estados internos se quiser resetar a busca
        setSearchTerm('');
        setProducts([]);
        setPage(1);
        setTotalPages(1);
        onClose();
    };

    const handleSelectClick = (product: ProductInterface) => {
        // onSelectProduct(product);
        handleClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>

            <DialogTitle>Pesquisar Produto</DialogTitle>
            <DialogContent>
                <ProductSearchCard style={{ marginBottom: '1rem' }}>
                    <TextField
                        id="modal_product_search"
                        label="Nome do Produto"
                        variant="outlined"
                        fullWidth
                        value={searchTerm}
                        onChange={e => {
                            setSearchTerm(e.target.value);
                            setPage(1); // se mudar o filtro, voltar para página 1
                        }}
                    />
                </ProductSearchCard>

                <TableContainer translate="no">
                    <Table>
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Quantidade</th>

                                <th>Preço</th>
                                <th>Localização</th>

                            </tr>
                        </thead>
                        <tbody>
                            {loading && (
                                <tr>
                                    <td colSpan={6} style={{ textAlign: 'center', padding: 20 }}>
                                        Carregando...
                                    </td>
                                </tr>
                            )}

                            {!loading && products.length === 0 && (
                                <tr>
                                    <td colSpan={6} style={{ textAlign: 'center', padding: 20 }}>
                                        Nenhum produto encontrado
                                    </td>
                                </tr>
                            )}

                            {products.map(prod => (
                                <tr key={prod.product_id}>
                                    <td>{prod.product_name}</td>
                                    <td>{prod.product_quantity}</td>
                                    <td>
                                        {Number(prod.product_unit_price)
                                            .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                    </td>
                                    <td>{prod.product_location ?? '-'}</td>

                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </TableContainer>

                {/* Paginação */}
                <PaginationControls
                    page={page}
                    totalPages={totalPages}
                    setPage={setPage}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ProductSearchModal;
